 
import { Grid, Menu, MenuItem } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  BasicAccordion,
  DottedText,
  Switch,
  TextField,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import Dropdown from '@HomaHealth/ui-component-library/lib/_AIQ-components/atoms/Dropdown';
import React, { useEffect, useState } from 'react';
import DotMenu from '../../atoms/Icons/DotMenu';
import BasicModal from '../../atoms/BasicModal';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';

export interface CheckOffList {
  question: string;
  category: string;
}
export interface SampleClause {
  main: string[];
  subData: string[];
}

export interface PlaybookClauseDetailsProps {
  clauseName: string;
  clauseId: number;
  standardId: string;
  aim: string[];

  checkOffList: CheckOffList[];
  sampleClause: SampleClause[];
  addPlaybookQuestion: (
     
    standard_id: string,
     
    clause_id: number,
     
    question: string,
     
    category: string,
  ) => void;
  changePlaybookQuestionCategory: (
     
    standard_id: string,
     
    clause_id: number,
     
    question_index: number,
     
    category: string,
  ) => void;
  ignorePlaybookClause: (
     
    standard_id: string,
     
    clause_id: number,
     
    isIgnored: boolean,
  ) => void;
  isIgnored: boolean;
  isEditable: boolean;
}
export const CheckOffQuestion = ({
  title,
  category = '',
  handleChange,
  index,
  isEditable,
}: {
  title: string;
  category?: string;
   
  handleChange?: (title: string, newCategory: string, index: number) => void;
  index: number;
  isEditable?: boolean;
}) => {
  return (
    <Grid
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: '1rem',
        backgroundColor: index % 2 === 0 ? '#FAFAFC' : '#F2F4FA',
        padding: '1rem',
      }}
    >
      <Typography
        fontSize="14px"
        fontType="regular"
        textColor={patientAccessTheme.palette.text.highemphasis}
      >
        {title}
      </Typography>
      {isEditable && (
        <Dropdown
          label={'Mandatory'}
          value={category}
          handleChange={(e) =>
            handleChange && handleChange(title, e.target.value as string, index)
          }
          dropDownOptions={[
            'Mandatory',
            'Negotiable but Most Preferred',
            'Negotiable but Preferred',
            'Negotiable but Optional',
            'Ignore',
          ]}
          dropDownValues={[
            'Mandatory',
            'Negotiable but Most Preferred',
            'Negotiable but Preferred',
            'Negotiable but Optional',
            'Ignore',
          ]}
          selectStyles={{
            height: '36px',
            width: '260px',
          }}
        />
      )}
    </Grid>
  );
};
const PlaybookClauseDetails: React.FC<PlaybookClauseDetailsProps> = ({
  clauseName,
  clauseId,
  standardId,
  aim,
  checkOffList,
  sampleClause,
  addPlaybookQuestion,
  changePlaybookQuestionCategory,
  ignorePlaybookClause,
  isIgnored,
  isEditable,
}) => {
  const useStyles = makeStyles()({
    subtitle: {
      fontSize: '14px',
      lineHeight: '22px',
      fontWeight: 400,
      letterSpacing: '0px',
      color: patientAccessTheme.palette.text.highemphasis,
    },
    menu: {
      marginTop: '52px',
      cursor: 'pointer',
    },
  });
  const { classes } = useStyles();

  const [checkOffQuestion, setCheckOffQuestion] = useState<CheckOffList[]>([]);
  const [anchorEl, setAnchorEl] = React.useState<null | SVGSVGElement>(null);
  const [checked, setChecked] = useState<boolean>(isIgnored);
  const [
    isAddNewQuestionModalOpen,
    setIsAddNewQuestionModalOpen,
  ] = useState<boolean>(false);
  const [isShowClauseModalOpen, setIsShowClauseModalOpen] = useState<boolean>(
    false,
  );

  useEffect(() => {
    setCheckOffQuestion(
      checkOffList.map((item) => ({
        question: item.question,
        category: item.category,
      })),
    );
  }, [checkOffList]);

  const handleAnswerChange = (
    question: string,
    category: string,
    index: number,
  ) => {
    setCheckOffQuestion((prev) =>
      prev.map((item) =>
        item.question === question ? { ...item, category } : item,
      ),
    );
    changePlaybookQuestionCategory(standardId, clauseId, index, category);
  };

  const isProfileMenuOpen = Boolean(anchorEl);

  const handleClauseMenuOpen = (
    event: React.MouseEvent<SVGSVGElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClauseMenuClose = () => {
    setAnchorEl(null);
  };
  const handleSwitchChange = () => {
    setChecked((prev: any) => !prev);
    ignorePlaybookClause(standardId, clauseId, isIgnored);
  };

  const renderClauseMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      keepMounted
      open={isProfileMenuOpen}
      onClose={handleClauseMenuClose}
      className={classes.menu}
    >
      <MenuItem
        onClick={() => {
          setIsShowClauseModalOpen(true);
          handleClauseMenuClose();
        }}
      >
        View Sample Clause
      </MenuItem>
      <MenuItem style={{ color: '#D6545E' }}>
        Ignore this Clause
        <div style={{ marginLeft: '0.5rem' }}>
          <Switch checked={checked} handleChange={handleSwitchChange} />
        </div>
      </MenuItem>
    </Menu>
  );

  const AddNewQuestionModal = () => {
    const [question, setquestion] = useState<string>('');
    const [importance, setImportance] = useState<string>('Mandatory');

    const handleQuestion = (event: any) => {
      const value = event.target.value as string;
      setquestion(value);
    };
    return (
      <BasicModal
        title="New Checkoff List Question"
        open={isAddNewQuestionModalOpen}
        handleClose={() => setIsAddNewQuestionModalOpen(false)}
        isSaveButton={true}
        saveBtnText="Add"
        saveBtnAction={() => {
          addPlaybookQuestion(standardId, clauseId, question, importance);
        }}
      >
        <ReportCreateNewLabelField
          label={'Question'}
          component={
            <TextField
              value={question}
              placeholder={'Check off List Question'}
              height="36px"
              width="650px"
              inputPropsStyle={{
                paddingLeft: '16px',
              }}
              onChange={(event: any) => handleQuestion(event)}
            />
          }
          marginBottom="12px"
        />
        <ReportCreateNewLabelField
          label={'Importance'}
          component={
            <Dropdown
              label={'Mandatory'}
              value={importance}
              setValue={setImportance}
              dropDownOptions={[
                'Mandatory',
                'Negotiable but Most Preferred',
                'Negotiable but Preferred',
                'Negotiable but Optional',
                'Ignore',
              ]}
              dropDownValues={[
                'Mandatory',
                'Negotiable but Most Preferred',
                'Negotiable but Preferred',
                'Negotiable but Optional',
                'Ignore',
              ]}
              selectStyles={{
                height: '36px',
                width: '650px',
                zIndex: 499,
              }}
            />
          }
          marginBottom="12px"
        />
      </BasicModal>
    );
  };

  const ShowSampleClauseModal = () => {
    return (
      <BasicModal
        title="Sample Clause"
        open={isShowClauseModalOpen}
        handleClose={() => setIsShowClauseModalOpen(false)}
        isSaveButton={false}
      >
        {sampleClause.map((clauseItem) => (
          <ul style={{ margin: '0 1rem 0 -20px' }}>
            {clauseItem.main.map((mainItem) => (
              <>
                <li>
                  <Typography
                    fontSize="14px"
                    fontType="regular"
                    lineHeight="25.2px"
                    align="justify"
                  >
                    {mainItem}
                  </Typography>
                </li>
                {clauseItem?.subData.length > 0 && (
                  <ul>
                    {clauseItem?.subData.map((subItem) => (
                      <li>
                        <Typography
                          fontSize="14px"
                          fontType="regular"
                          lineHeight="25.2px"
                          align="justify"
                        >
                          {subItem}
                        </Typography>
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ))}
          </ul>
        ))}
      </BasicModal>
    );
  };

  return (
    <Grid>
      <BasicAccordion
        title={clauseName}
        content={
          <Grid
            container
            style={{ gap: '1rem' }}
            sx={{
              flexDirection: 'column',
            }}
          >
            <Grid>
              <ul style={{ margin: '0 0 0 -20px' }}>
                {aim?.map((listItem, index) => (
                  <li key={index}>
                    <Typography lineHeight="27px" className={classes.subtitle}>
                      {listItem}
                    </Typography>
                  </li>
                ))}
              </ul>
            </Grid>

            <BasicAccordion
              title={'Check off List'}
              content={
                <Grid>
                  {checkOffQuestion?.map((item, index) => (
                    <CheckOffQuestion
                      title={item.question}
                      category={item.category}
                      handleChange={handleAnswerChange}
                      index={index}
                      key={item.question}
                      isEditable={isEditable}
                    />
                  ))}
                </Grid>
              }
              rightItem={
                <div
                  style={{ marginLeft: 'auto' }}
                  onClick={() => setIsAddNewQuestionModalOpen(true)}
                >
                  <DottedText text="+ Add a New Question" />
                </div>
              }
              accordionDetailsStyles={{ padding: 0 }}
            />
          </Grid>
        }
        width="100%"
        titleStyles={{
          width: '100%',
        }}
        rightItem={
          <DotMenu height={32} width={32} onClick={handleClauseMenuOpen} />
        }
        isDisabled={isIgnored}
      />
      {renderClauseMenu}
      <AddNewQuestionModal />
      <ShowSampleClauseModal />
    </Grid>
  );
};

export default PlaybookClauseDetails;
